import { setProductFlag, buildProductFlag } from "./productFlags";

export function setEarlyAccessProductFlag({ product }) {
  setProductFlag(buildProductFlag({ key: "eap", shown: product.earlyAccess }));
}
